/* PDP Size Guide — dialog behavior. Scoped to #pdp-size-guide only. */
(function () {
  'use strict';

  var dialog = document.getElementById('pdp-size-guide');
  if (!dialog) return;

  var panel = dialog.querySelector('.pdp-sg__dialog');
  var lastTrigger = null;
  var isOpen = false;

  function focusables() {
    return Array.prototype.slice.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function open(trigger) {
    if (isOpen) return;
    isOpen = true;
    lastTrigger = trigger || null;
    dialog.hidden = false;
    document.documentElement.classList.add('pdp-sg-lock');
    document.addEventListener('keydown', onKeydown, true);
    var closeBtn = dialog.querySelector('.pdp-sg__close');
    (closeBtn || panel).focus();
  }

  function close(restoreFocus) {
    if (!isOpen) return;
    isOpen = false;
    dialog.hidden = true;
    document.documentElement.classList.remove('pdp-sg-lock');
    document.removeEventListener('keydown', onKeydown, true);
    if (restoreFocus !== false && lastTrigger) {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab' && e.keyCode !== 9) return;
    var nodes = focusables();
    if (!nodes.length) {
      e.preventDefault();
      panel.focus();
      return;
    }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  }

  function setAccordion(btn, expand) {
    var panelEl = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', expand ? 'true' : 'false');
    if (panelEl) panelEl.hidden = !expand;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pdp-sg-open]');
    if (opener) {
      e.preventDefault();
      open(opener);
      return;
    }
    if (!isOpen || !e.target.closest) return;
    if (e.target.closest('#pdp-size-guide [data-pdp-sg-close]')) {
      e.preventDefault();
      close();
    }
  });

  dialog.addEventListener('click', function (e) {
    var accBtn = e.target.closest('.pdp-sg__acc-btn');
    if (accBtn) {
      var expand = accBtn.getAttribute('aria-expanded') !== 'true';
      var all = dialog.querySelectorAll('.pdp-sg__acc-btn');
      for (var i = 0; i < all.length; i++) setAccordion(all[i], false);
      setAccordion(accBtn, expand);
      return;
    }
    /* Handing off to a Globo form: close the guide first, release locks,
       then let the click continue to the app's delegated handlers. */
    if (e.target.closest('.open-MTA1NTA0, .open-MTA1NjQ2, .open-MTE2NDU2, .open-MTI3MDA0')) {
      close(false);
    }
  });
})();
